export const PROFILE_COMPLETION_SCORING = Object.freeze({
  tenant: Object.freeze({
    basicInformation: 5,
    kyc: 20,
    requiredDocuments: 35,
    targetRent: 10,
    bankConnection: 10,
  }),
  guarantor: Object.freeze({
    basicInformation: 5,
    kyc: 20,
    requiredDocuments: 35,
    bankConnection: 10,
    maximumContribution: 20,
  }),
  kyc: Object.freeze({
    pendingPoints: 8,
    approvedStatuses: Object.freeze(["approved", "clear", "completed"]),
    pendingStatuses: Object.freeze([
      "pending",
      "processing",
      "in_progress",
      "awaiting_input",
      "review",
    ]),
    rejectedStatuses: Object.freeze(["rejected", "declined", "failed"]),
  }),
});
